import React, { useState } from "react";
import Sidebar from "../Components/Sidebar";
import { FiPhone, FiMail } from "react-icons/fi";
import { HiOutlineOfficeBuilding } from "react-icons/hi";

export default function ContactUs() {
  const [isVisible, setIsVisible] = useState(true);

  return isVisible ? (
    <>
      <Sidebar>
        <div className="p-3 overflow-auto bg-gray-300 lg:p-3 xl:p-3 2xl:p-6">
          <div
            className="bg-white h-[78.55vh] flex flex-col justify-start items-center p-8 lg:p-12 xl:p-16 2xl:p-24"
            style={{ borderRadius: "0px 0px 11px 11px" }}
          >
            <div className="w-full max-w-4xl bg-gray-50 border border-gray-200 rounded-xl shadow-lg p-8 md:p-12">
              <h2 className="text-3xl font-bold text-gray-800 mb-2 border-b-2 border-[#FF9900] pb-4">
                Contact Us
              </h2>
              <p className="text-gray-600 mb-8">
                If you have any queries, issues, or need support with the admin dashboard, please reach out to us.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Company Card */}
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center text-center">
                  <div className="p-4 bg-orange-100 text-[#FF9900] rounded-full mb-4">
                    <HiOutlineOfficeBuilding className="text-3xl" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">Company</h3>
                  <p className="text-gray-600 font-medium">Texpidea Technologies PVT.LTD</p>
                </div>

                {/* Phone Card */}
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center text-center">
                  <div className="p-4 bg-orange-100 text-[#FF9900] rounded-full mb-4">
                    <FiPhone className="text-3xl" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">Phone</h3>
                  <p className="text-gray-600 font-medium">
                    +91 9665664966
                  </p>
                  <p className="text-gray-600 font-medium">
                    +91 9975750166
                  </p>
                </div>

                {/* Email Card */}
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center text-center">
                  <div className="p-4 bg-orange-100 text-[#FF9900] rounded-full mb-4">
                    <FiMail className="text-3xl" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">Email</h3>
                  <a
                    href="mailto:support@texpidea.com"
                    className="text-[#FF9900] hover:underline font-semibold"
                  >
                    support@texpidea.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Sidebar>
    </>
  ) : null;
}
